import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { CronsInterfaceAdd, CronsInterfaceUpdate } from './crons.interface';
@Injectable({
	providedIn: 'root'
})
export class CronsService {
	private token!: string;
	private httpOptions: any;

	private basePath = environment.interop.basePath;

	//Getters
	private getCronsDTURL = this.basePath + environment.interop.urbanism.nomenclatoare.crons.listDT;
	private getCronsActiveURL = this.basePath + environment.interop.urbanism.nomenclatoare.crons.listActive;
	//Updates
	private storeCronsURL = this.basePath + environment.interop.urbanism.nomenclatoare.crons.store;
	private updateCronsURL = this.basePath + environment.interop.urbanism.nomenclatoare.crons.update;
	private deleteCronsURL = this.basePath + environment.interop.urbanism.nomenclatoare.crons.delete;
	private cronChangeStatusActive = this.basePath + environment.interop.urbanism.nomenclatoare.crons.updateStatus;

	constructor(private http: HttpClient) { }

	getCronsDT() {
		return this.http.get(this.getCronsDTURL, this.httpOptions);
	}

	addCrons(crons: CronsInterfaceAdd) {
		return this.http.post(this.storeCronsURL, crons, this.httpOptions);
	}

	updateCrons(crons: CronsInterfaceUpdate) {
		return this.http.put(this.updateCronsURL, crons, this.httpOptions);
	}

	deleteCrons(cronsId: number) {
		return this.http.delete(this.deleteCronsURL + cronsId, this.httpOptions);
	}

	getCronsActive() {
		return this.http.get(this.getCronsActiveURL, this.httpOptions);
	}

	changeStatusActive(id: number) {
		return this.http.put(
			this.cronChangeStatusActive + id,
			this.httpOptions
		);
	}

	setToken(token: string) {
		this.token = token;
		this.httpOptions = {
			headers: new HttpHeaders({
				'Content-Type': 'application/json',
				Accept: 'application/json',
				Authorization: `Bearer ${this.token}`,
			}),
		};
	}
}
